export default __webpack_public_path__ + "static/media/m2_institute.983a1819.jpg";